/* eslint-disable no-unused-vars */

import React, {Component} from "react";
import {FormControlLabel, TextField, withStyles} from "@material-ui/core";
import classNames from 'classnames';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const styles = theme => ({
    input: {
        width: '100%',
    },
    wrapper:{
        paddingLeft:'8px',
        paddingRight:'8px'
    }
});

class RadioInput extends Component {
    state = {
        active:     this.props.active || 1
    }

    render() {
        const { classes, possibleValues, value, width, onChange, fieldLabel, fieldName, fieldValue} = this.props;
        const { active } = this.state;

        return (
            <React.Fragment>
                <div className={classNames(classes.wrapper,width)}>
                    {/*<label>{fieldLabel}</label>
                    <input className={classes.input} name={fieldName} onChange={onChange} value={fieldValue} />
                    <TextField id="standard-basic" label={fieldLabel} className={classes.input}/>*/}


                    <FormControl component="fieldset">
                        <FormLabel component="legend">{fieldLabel}</FormLabel>
                        <RadioGroup aria-label="gender" name={fieldName} value={fieldValue}>
                            {possibleValues.map(o=>{
                                return(
                                <FormControlLabel value={o.value} control={<Radio />} label={o.label} disabled={o.disabled}/>
                                )
                            })}
                        </RadioGroup>
                    </FormControl>

                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(RadioInput);


// WEBPACK FOOTER //
// ./src/yeffect/formBuilder/components/RadioInput.js